import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
@Component({
    selector: 'bergh-paginator',
    templateUrl: './paginator.component.html',
    styleUrls: ['./paginator.component.scss'],
    standalone: false
})
export class PaginatorComponent implements OnInit {
  @Input() total: number;
  @Input() itemPerPage: number;
  @Input() currentPageNumber: number;
  @Output() currentPageChange: EventEmitter<number> = new EventEmitter();

  public currentPage: number = 1;
  public totalPages: number;
  public pages: number[] = [];
  public showMore: boolean = false;
  public showLess: boolean = false;
  constructor() { }

  ngOnInit(): void {
    this.currentPage = this.currentPageNumber;
    this.totalPages = this.getTotalPage(this.total,this.itemPerPage);
    this.renderNumberTiles();
  }

  public getTotalPage(total: number, itemsPerPage: number): number {
    return Math.ceil(total/itemsPerPage);
  }

  public renderNumberTiles(){
    if(this.totalPages > 5){
      this.showMore = true;
      this.pages=[1,2,3,4,5];
    } else {
      for (let i = 0; i < this.totalPages; i++) {
        this.pages.push(i+1);
      }
    }
  }
  public goToEnd(){
    this.showLess = true;
    this.showMore = false;
    this.pages = [];
    let sub = this.totalPages%5 != 0 ? this.totalPages%5 : 5
    for (let i = this.totalPages-sub+1; i <= this.totalPages; i++) {
      this.pages.push(i); 
    }
    this.currentPage = this.totalPages;
    this.currentPageChange.emit(this.currentPage);
  }
  public goToStart(){
    this.showLess = false;
    this.showMore = true;
    if(this.totalPages > 5){
      this.pages=[1,2,3,4,5];
    } else {
      for (let i = 0; i < this.totalPages; i++) {
        this.pages.push(i+1);
      }
    }
    this.currentPage = 1;
    this.currentPageChange.emit(this.currentPage);
  }
  public next(){
    if(this.currentPage === this.pages[this.pages.length-1]){
      this.pages = [];
      if(this.totalPages-this.currentPage > 5){
        this.showLess=true;
        for (let i = this.currentPage+1; i < this.currentPage+6; i++) {
          this.pages.push(i);
        }
      } else {
        this.showMore = false;
        for (let i = this.currentPage+1; i <= this.totalPages; i++) {
          this.pages.push(i);
        }
      }
    }
    this.currentPage++;
    this.currentPageChange.emit(this.currentPage);
  }
  public previous(){
    if(this.currentPage === this.pages[0]){
      this.pages = [];
      for (let i = this.currentPage-5; i < this.currentPage; i++) {
        this.pages.push(i);
      }
      if(this.currentPage === 6){
        this.showLess = false;
      }
      if(this.pages[this.pages.length-1] != this.totalPages){
        this.showMore = true;
      }
    }
    this.currentPage--;
    this.currentPageChange.emit(this.currentPage);
  }
}